module.exports = __webpack_public_path__ + "img/amex.2e45b6b3.png";